import { CompostIcon } from './CompostIcon';

/**
 * author: Google
 * id 75C5A894-CC25-4326-A270-6F70BE0D8AAB
 * name compost
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/compost.svg
 * tags
 * - Agriculture 
 * - Nature 
 */
export const RegenerativeAgricultureIcon = CompostIcon;
export default RegenerativeAgricultureIcon